import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import Countdown from 'react-countdown';
import Modal from '../Modal';

function SessionExtendModal({ expires, onExtension, onExpire }) {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  let showModalTimeout;

  useEffect(() => {
    showModalTimeout = setExpiryTimeout();

    return () => {
      clearTimeout(showModalTimeout);
    };
  }, []);

  useEffect(() => {
    clearTimeout(showModalTimeout);

    showModalTimeout = setExpiryTimeout();
  }, [expires]);

  function setExpiryTimeout() {
    /*let testingOffset = 54 * 60 * 1000;*/ // 54 mins offset for testing pruposes (remove or set to 0 when finished)
    const minutesRemainingBeforeShowing = 5;
    const expiresSeconds = expires * 1000; /* - testingOffset;*/
    const now = Math.floor(Date.now());

    return setTimeout(() => {
      setIsOpen(true);
    }, expiresSeconds - now - minutesRemainingBeforeShowing * 60 * 1000);
  }

  function handleClose() {
    clearTimeout(showModalTimeout);

    setIsOpen(false);
  }

  function handleYes() {
    clearTimeout(showModalTimeout);

    setIsOpen(false);

    if (typeof onExtension === 'function') {
      onExtension();
    }
  }

  function handleNo() {
    clearTimeout(showModalTimeout);

    setIsOpen(false);

    if (typeof onExpire === 'function') {
      onExpire();
    }
  }

  return (
    <Modal isOpen={isOpen} title={t('styleguide:components.sessionExtendModal.title')} onOpenChange={handleClose}>
      <div className="form-wrap">
        <Trans i18nKey={'styleguide:components.sessionExtendModal.body'}>
          <p>
            <Countdown
              date={expires * 1000}
              renderer={(props) => (
                <span>
                  {props.formatted.minutes}:{props.formatted.seconds}
                </span>
              )}
              onComplete={onExpire}
            />
          </p>
        </Trans>
        <div className="form__footer">
          <button className="button button--secondary form__button-cancel" onClick={handleNo}>
            {t('styleguide:components.sessionExtendModal.action.no')}
          </button>
          <button className="button form__button-submit" onClick={handleYes}>
            {t('styleguide:components.sessionExtendModal.action.yes')}
          </button>
        </div>
      </div>
    </Modal>
  );
}

SessionExtendModal.propTypes = {
  /**
   * The expiry timestamp
   */
  expires: PropTypes.number,
  /**
   * The extension handler
   */
  onExtension: PropTypes.func,
  /**
   * The expire handler
   */
  onExpire: PropTypes.func
};

export default SessionExtendModal;
